<template>
  <div class="plv-iar-order-phone-input-wrap">
    <div :class="['plv-iar-order-phone-input', { 'plv-iar-order-phone-input--error' : errors.length }]">
      <span class="plv-iar-opi-label">{{ iarTrans('order.phoneLabel') }}：</span>
      <div class="plv-iar-opi-control-input">
        <input
          ref="mobileInput"
          class="plv-iar-opi-input"
          type="tel"
          v-model="mobile"
          :placeholder="iarTrans('order.phoneLabel')"
          @focus="handleFoucs"
          @blur="handleInputBlur"
        />
        <span
          v-show="isFoucs"
          ref="clearButton"
          class="plv-iar-opi-input-clear-icon"
          @click="handleClear">
        </span>
      </div>
    </div>
    <div v-if="errors.length" class="plv-iar-opi-error-msg">{{ errors[0].message }}</div>
  </div>
</template>

<script>
import mixin from './mixin';

export default {
  mixins: [mixin]
};
</script>

<style lang="scss">
.plv-iar-order-phone-input {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 12px;
  box-sizing: border-box;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  border: 1px solid #fff;
  transition: border-color .2s;
  background: #fff;

  input, textarea {
    font-size: 14px;
    font-weight: 400;
  }

  &.plv-iar-order-phone-input--error {
    border-color: #FF6363;
  }

  .plv-iar-opi-label {
    flex-shrink: 0;
    margin-right: 12px;
  }

  .plv-iar-opi-control-input {
    flex-grow: 1;
    position: relative;
    padding-right: 28px;
  }

  .plv-iar-opi-input {
    display: block;
    padding: 0;
    width: 100%;
    height: 44px;
    border: none;
    outline: none;
    color: inherit;
    background: transparent;

    &::placeholder {
      color: rgba(0, 0, 0, 0.4);
    }
  }

  .plv-iar-opi-input-clear-icon {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    background: url('../images/close-circle-filled.svg') no-repeat;
  }
}

.plv-iar-order-phone-input-wrap {
  .plv-iar-opi-error-msg {
    margin-top: 4px;
    color: #FF6363;
    font-size: 12px;
  }
}
</style>
